import { ZonedDateTime, ZoneId, ZoneOffset } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
import { createLocalDateTimeFromInternals } from './LocalDateTimeSerializer';
import { createZoneIdFromInternals } from './ZoneIdSerializer';
/**
 * Serializer for ZonedDateTime
 */
export const zonedDateTimeSerializer = CreateSerializer(serializeZonedDateTime, deserializeZonedDateTime);
/*
  Differently from other js-joda serialized values, ZonedDateTime has nested objects with their own prototypes.
  Hence, a mere Object.assign doesn't work here (Object.assign does a shallow copy only).
  As a simplistic workaround, we rely on knowing js-joda's ZoneDateTime's internals here to map private fields to their
  prototypes.
 */
function serializeZonedDateTime(value) {
    const localDateTime = createLocalDateTimeFromInternals(value._dateTime);
    const zoneId = createZoneIdFromInternals(value._zone);
    const zoneOffset = ZoneOffset.of(value._offset._id);
    const time = ZonedDateTime.ofLocal(localDateTime, zoneId, zoneOffset);
    return time.withZoneSameInstant(ZoneId.UTC).toString();
}
function deserializeZonedDateTime(value) {
    return ZonedDateTime.parse(value);
}
